import { render, staticRenderFns } from "./Klinika.vue?vue&type=template&id=368fdf52&"
import script from "./Klinika.vue?vue&type=script&lang=js&"
export * from "./Klinika.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports